import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { DJCPay as dpCore } from '@tencent/milo-core';

var DJCPayComp = /*#__PURE__*/function (_dpCore) {
  _inherits(DJCPayComp, _dpCore);

  var _super = _createSuper(DJCPayComp);

  function DJCPayComp(option) {
    _classCallCheck(this, DJCPayComp);

    return _super.call(this, option);
  }

  return _createClass(DJCPayComp);
}(dpCore);

export { DJCPayComp as default };
export var DJCPay = {
  pay: function pay(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new DJCPayComp(option);
        return instance.pay();
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: '支付模块初始化失败'
        });
      }
    });
  }
};